import { ValidatedDropDownList, ValidatedInput } from '@finbeat/react-toolkit';
import { TariffsInfo } from 'models/api/tariff';
import { useTariffInfoState } from 'providers/TariffInfoProvider';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { TariffAccesses } from './TariffsModal';

const TariffsModalMain = ({ fullAccess, partialAccess }: TariffAccesses) => {
    const { t } = useTranslation();
    const { coverGroups, coverGroupsLoading, dicts, dictsLoading } = useTariffInfoState();

    return (
        <Container>
            <Row>
                <Col>
                    <ValidatedInput<TariffsInfo>
                        name="isActive"
                        label={t('BackOfficeIsActive')}
                        type="checkbox"
                        disabled={!fullAccess}
                    />
                </Col>
            </Row>
            <hr />
            <Row>
                <Col>
                    <ValidatedInput<TariffsInfo>
                        name="name"
                        label={t('BackOfficeName')}
                        disabled={!fullAccess && !partialAccess}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<TariffsInfo>
                        name="apr"
                        type="number"
                        label={t('BackOfficeInterestRate')}
                        disabled={!fullAccess && !partialAccess}
                    />
                </Col>
                <Col>
                    <ValidatedDropDownList<TariffsInfo>
                        name="coverGroupId"
                        label={t('BackOfficeCoveragePrioritiesForAccruals')}
                        items={coverGroups}
                        isLoading={coverGroupsLoading}
                        isSearchable={false}
                        disabled={!fullAccess}
                        isClearable={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<TariffsInfo>
                        name="minTerm"
                        label={t('BackOfficeMinTerm')}
                        disabled={!fullAccess}
                    />
                </Col>
                <Col>
                    <ValidatedInput<TariffsInfo>
                        name="maxTerm"
                        label={t('BackOfficeMaxTerm')}
                        disabled={!fullAccess}
                    />
                </Col>
                <Col>
                    <ValidatedDropDownList<TariffsInfo>
                        name="termUnits"
                        label={t('BackOfficeTermUnits')}
                        items={dicts.termUnits}
                        isLoading={dictsLoading}
                        isSearchable={false}
                        disabled={!fullAccess}
                        isClearable={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<TariffsInfo>
                        name="dsc"
                        label={t('BackOfficeDescription')}
                        disabled={!fullAccess && !partialAccess}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default TariffsModalMain;
